<template>
  <v-app style="background-color:white;margin-top:140px">
     <go-top></go-top>
     <div style="padding-top:10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr txt">Home</span> / <span class="txt" style="color:#7FB4FD">All Categories</span></p>
     </div>
     
     

     <div class="container">
         <v-layout row wrap>
             <v-flex xs12 sm12 md3 style="padding:10px" v-for="item in categories" :key="item.id">
                 <v-card style="background-color:#eeeeee;padding:0px;" flat class="hvr" @click="detail(item)">
              <img :src=item.src style="border-radius:5px;width:100%;height:250px;" />
               <h6 style="text-align:center;padding:15px;" class="txt">{{item.categoryName}}</h6>
                 <div style="text-align:center;margin-top:0px">
                 </div>
            </v-card>
             </v-flex>
         </v-layout>
     </div>
  </v-app>
</template>

<script>
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';
import config from "./../../config.json";

export default {
  components: {
    GoTop,
  },
  data() {
    return {
      valid: true,
      isLoading: false,
      text: null,
      read: false,
      categories: [],

      form: {},

      
    };
  },
  
   mounted() {
       this.axios
        .get(config.API + "Home", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.categories = res.data.categories;
        });
   },

 methods: {
     detail(item) {
     sessionStorage.setItem("id", item.id);
     this.$router.push(`/detail`);
   },
     home(){
         this.$router.push(`/demo`);
     }
 },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap');
</style>

<style scoped>
.txt {
  font-family: 'Montserrat', sans-serif !important;
}
.about-us-img {
    background-image: url('https://sasitechnologies.in/csquad/assets/images/bg/bg-2.png');
    background-size: cover;
}
.zero {
    color: #4e97fd;
    font-size: 150px;
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.hvr :hover {
    color: #3486D7 !important;
}
</style>
